import { pickT } from "@repo/shared";
import type { PortfolioOrderType } from "@repo/shared/types";
import { Badge } from "@/components/ui/badge";
import { T } from "./order-type-badge.i18n";

const VARIANTS: Record<PortfolioOrderType, "success" | "destructive" | "secondary" | "info"> = {
  buy: "success",
  sell: "destructive",
  keep: "secondary",
  switch: "info",
};

type OrderTypeBadgeProps = {
  orderType: PortfolioOrderType;
  /** UI language; unknown codes fall back to en_GB. */
  language: string;
  /** Optional hover text (the builder passes its per-direction tooltips). */
  title?: string;
  className?: string;
};

export function OrderTypeBadge({ orderType, language, title, className }: OrderTypeBadgeProps) {
  const t = pickT(T, language);
  return (
    <Badge variant={VARIANTS[orderType]} className={className ?? "text-xs"} title={title}>
      {t.type[orderType]}
    </Badge>
  );
}
